<template>
  <header class="c-header">
    <img src="../../assets/images/pebblesblue.png" alt="" />
    <h1>Try</h1>
    <strong>Success is not final, failure is not fatal. It's the courage to continue that counts.</strong>
    <h5>The Real You</h5>
  </header>
</template>

<script>
export default {
  name: "Branding",
  data() {
    return {};
  }
};
</script>

<style lang="scss" scoped>
.c-header {
  width: 100%;
  max-width: 375px;
  margin: 50px auto;
  text-align: center;

  &.small {
    max-width: 100px;
    margin-bottom: 0;
  }
}

h1 {
  font-family: "Rajdhani", "Roboto", sans-serif;
  font-size: 3rem;
  font-weight: 300;
  margin-top: 0;

  .small & {
    font-size: 2rem;
  }
}

h5 {
  font-family: "Dawning of a New Day", cursive;
  font-size: 2rem;
  text-align: right;
}

.small {
  strong,
  h5 {
    display: none;
  }
}
</style>
